import axios from "axios";
import { getOrigin, getWwsBotId } from "../utils/widgetStorage";

// Configure domain based on the environment it is running in
function getDomain() {
	const hostDomain = window.location.hostname;
	if (hostDomain.includes("stage")) {
		return 'https://stage-app.intelswift.com';
	} else if (hostDomain.includes("localhost")) {
		return 'http://localhost';
	} else {
		return 'https://app.intelswift.com';
	}
}


class AxiosInstance {
	constructor(prefix) {
		this._axiosInstance = axios.create({ baseURL: prefix || "/api/v1" });


		this._axiosInstance.interceptors.request.use(
			function (config) {
				if (!(config.data instanceof FormData)) {
					config.headers["Content-Type"] = "application/json";
				  } else {
					delete config.headers["Content-Type"];
				  }
				const urlData = getOrigin();
				const botId = getWwsBotId();

				if (urlData && !config.headers["X-Host"] && !config.headers["X-Pathname"]) {
					config.headers["X-Host"] = urlData.hostname;
					config.headers["X-Pathname"] = urlData.pathname;
				}

				if (botId && config?.params) {
					config.params.botId = botId;
				}

				return config;
			},
			function (error) {
				return Promise.reject(error);
			}
		);

		this._axiosInstance.interceptors.response.use(
			function (response) {
				return response;
			},
			async function (error) {
				const config = error.config;

				// Only retry if config exists and not marked to skip retry
				if (!config || config.__retryCount >= 3) {
					return Promise.reject(error);
				}

				// Init retry count if missing
				config.__retryCount = config.__retryCount || 0;
				config.__retryCount += 1;

				// Simple backoff: 200ms * retryCount
				const delay = (ms) => new Promise((res) => setTimeout(res, ms));
				await delay(200 * config.__retryCount);
				// Retry the request
				return axios(config);
			}
		);
	}

	get axiosInstance() {
		return this._axiosInstance;
	}

	set axiosInstance(instance) {
		this._axiosInstance = instance;
	}
}

const axiosWAS = new AxiosInstance(`${getDomain()}/api/v1`).axiosInstance;
const axiosUCS = new AxiosInstance(`${getDomain()}/atombot/api/v1`).axiosInstance;
const axiosUPS = new AxiosInstance(`${getDomain()}/ups/api/v1`).axiosInstance;
const axiosUAS = new AxiosInstance(`${getDomain()}/uas/api/v1`).axiosInstance;

export {
	axiosWAS,
	axiosUCS,
	axiosUPS,
	axiosUAS,
	getDomain
};
